import request from '@/utils/request'
const context = require('./context')

export function queryDirsYearsList() {
  return request({
    url: context.EEOP + '/dirs',
    method: 'get'
  })
}

export function queryDirsList(params) {
  return request({
    url: context.EEOP + '/dirs/queryDirsList/'+params,
    method: 'get'
  })
}

export function updateStatus(data) {
	return request({
			url: context.EEOP + '/dirs/updateStatus',
			method: 'post',
			data: data
	})
}





// WEBPACK FOOTER //
// ./src/api/basis.js